module.exports = __webpack_public_path__ + "img/public-logo.bbb82a2b.svg";